module.exports = __webpack_public_path__ + "img/signing_options_min.724ddc26.jpg";